import React, { useContext, useEffect, useState } from 'react';
import { View } from 'react-native';
import { useLazyQuery } from '@apollo/client';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';

import ClientContext from 'app/src/contexts/ClientContext';
import {
  FieldLabel,
  StyledTextInput,
  StyledPicker,
} from 'app/src/elements/inputs';
import { Picker } from 'app/src/elements/Picker';
import { Text, Warning } from 'app/src/styles';

import { CHECK_LICENSE_REGISTRATION } from './queries';

export const LICENSE_TYPES = [
  { value: '', labelTranslation: 'options.licenseType.select' },
  { value: 'UD', labelTranslation: 'options.licenseType.ud' },
  { value: 'D', labelTranslation: 'options.licenseType.d' },
  { value: 'DM', labelTranslation: 'options.licenseType.dm' },
  { value: 'TV', labelTranslation: 'options.licenseType.tv' },
  { value: 'CT', labelTranslation: 'options.licenseType.ct' },
  { value: 'C', labelTranslation: 'options.licenseType.c' },
];

export const LICENSE_RULES =
  { required: 'errors.license.typeAndNumberRequired' };

const Inputs = styled.View`
  flex-direction: row;
  margin-bottom: 10px;
`;

const LicenseInput = props => {
  const {
    license, index, control, rules, hint, errors, checkRegistered
  } = props;

  const { t } = useTranslation();
  const { currentUser, isMobile } = useContext(ClientContext);
  const [admins, setAdmins] = useState([]);

  const [checkLicenseRegistration] = useLazyQuery(CHECK_LICENSE_REGISTRATION, {
    onCompleted: data => setAdmins(data.checkLicenseRegistration)
  });

  if (errors.licensesAttributes?.[index]?.licenseType) {
    errors.licensesAttributes[index].licenseNumber =
      errors.licensesAttributes[index].licenseType;
  }

  useEffect(() => {
    if (
      checkRegistered &&
      license.licenseType && license.licenseNumber.length >= 4
    ) {
      checkLicenseRegistration({ variables: license });
    }
  }, [license.licenseType, license.licenseNumber]);

  return (
    <View>
      <FieldLabel
        name={`licensesAttributes.${index}.licenseNumber`}
        label={`${t('labels.license')} #${index + 1}`}
        hint={t(hint)}
        errors={errors}
      />
      <Inputs>
        <Controller
          control={control}
          name={`licensesAttributes.${index}.licenseType`}
          rules={rules}
          render={({ field }) => (
            <StyledPicker
              selectedValue={field.value}
              onValueChange={field.onChange}
              style={isMobile ? { width: '50%' } : {}}
            >
              {LICENSE_TYPES.map(item => (
                <Picker.Item
                  key={item.value}
                  value={item.value}
                  label={t(item.labelTranslation)}
                />
              ))}
            </StyledPicker>
          )}
        />
        <Controller
          control={control}
          name={`licensesAttributes.${index}.licenseNumber`}
          rules={{
            ...rules,
            maxLength: {
              value: 9,
              message: 'errors.license.tooLong',
            },
            validate: value => (
              !value.toUpperCase().startsWith('YHZ') ||
                t('errors.license.notTag')
            ),
          }}
          render={({ field }) => (
            <StyledTextInput
              {...field}
              onChangeText={field.onChange}
              style={isMobile ? { width: '50%' } : {}}
            />
          )}
        />
      </Inputs>
      {admins.length > 0 && (
        <Warning>
          <Text style={{ marginBottom: 12 }}>
            {t('errors.license.alreadyRegistered')}
          </Text>

          {admins.map(contact => (<Text key={contact}>{contact}</Text>))}
        </Warning>
      )}
    </View>
  );
};

export default LicenseInput;
